import dynamic from 'next/dynamic'
import { Navigation } from 'components/Navigation'
import { StickyFooter } from 'components/StickyFooter'
import { SkillsYoullLearnSection } from '../components/variant_2/sections'
import { Hero } from '../components/variant_2/sections/Hero'

const BelowTheFold = dynamic(
  () =>
    import('../components/variant_2/BelowTheFold').then((m) => m.BelowTheFold),
  {
    ssr: false,
  },
)

export const Variant2PageContent = () => (
  <div>
    {/* If this variant wins, remove this Navigation component and the hideNavigation: true prop from classes/[slug] */}
    <Navigation />
    <Hero />
    <SkillsYoullLearnSection />
    <BelowTheFold />
    <StickyFooter />
  </div>
)
